import { FirebaseClient } from "../types";

export const injectDataOwner = <T extends object>(data?: T, firebase: FirebaseClient) => ({
  dataOwner: firebase.auth.currentUser.uid,
  ...data
});
